import BaseAPI from "../api";

const path: string = "/visa-intendant";

export class VisaIntendantApi extends BaseAPI {
  static list(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patch(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static delete(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
